import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';

const useInsertVersion = () => {
  const { enqueueSnackbar } = useSnackbar();

  const insertRequest = (
    getVersionList,
    setIsInsertModalOpen,
    setInsertLoading,
    insertVersionArgs,
    onSuccess,
  ) => {
    axiosClient
      .post(
        `/SettingSystem/Application/VersionControl/Insert`,
        insertVersionArgs,
      )
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`افزودن نسخه با موفقیت انجام شد`, {
            variant: 'success',
          });
          getVersionList();
          setIsInsertModalOpen(false);
          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setInsertLoading(false));
  };
  return [insertRequest];
};

export default useInsertVersion;
